<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="title-icon" color="warn" aria-hidden="true">warning</mat-icon>
  <span>Delete site configuration</span>
</h2>

<mat-dialog-content class="dialog-body" [formGroup]="form">
  <div class="danger-panel" role="alert">
    <p class="danger-lead">
      You are about to <strong>permanently delete</strong> this site configuration. This cannot be undone.
    </p>
    <ul class="danger-list">
      <li>The configuration record will be removed from the database.</li>
      <li>All uploaded media for this configuration (logo, header, favicon, hero image/video, and category tile images) will be deleted from storage.</li>
    </ul>
  </div>

  <p class="target-summary">
    <strong>Site name:</strong> {{ data.siteName }}<br />
    <strong>Location id:</strong> <code>{{ expectedLocation }}</code>
  </p>

  @if (data.isActive) {
    <p class="active-warning" role="status">
      <mat-icon aria-hidden="true">error</mat-icon>
      This is the <strong>active</strong> configuration. After deletion, no configuration may be marked active until you set another one.
    </p>
  }

  <p class="step-intro">
    To continue, acknowledge the warning below. The confirmation field appears only after that.
  </p>

  <mat-checkbox formControlName="acknowledged" color="warn" class="ack-checkbox">
    I understand this will permanently delete the configuration and all related files in storage, and that this action cannot be undone.
  </mat-checkbox>

  @if (form.controls.acknowledged.value) {
    <mat-form-field appearance="outline" class="confirm-field" subscriptSizing="dynamic">
      <mat-label>Type the location id to confirm</mat-label>
      <input matInput formControlName="confirmPhrase" [attr.autocomplete]="'off'" [placeholder]="expectedLocation" />
      <mat-hint>Enter exactly: {{ expectedLocation }}</mat-hint>
    </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-flat-button
    color="warn"
    type="button"
    [disabled]="!canDelete"
    (click)="confirmDelete()">
    Delete permanently
  </button>
</mat-dialog-actions>
